import { Button, Group, Stack } from '@mantine/core';
import { modals } from '@mantine/modals';
/* eslint-disable max-statements */
import { cloneDeep } from 'lodash';

import { Declaration, DeclarationDocumentsEnum, DeclarationGoods, Documents } from '@e-origin/shared';

import { DeclarationDocumentList, DocumentChangeProps, getDeclarationDocumentById, getDeclarationDocumentPos } from '@components';
import { MutateDeclarationDocumentOperation } from '@hooks/declaration';
import { useDeclarationViewGoodLVForm } from './useViewGoodLVDocumentsForm';

interface ViewGoodLVDocumentsProps {
  declaration: Declaration;
  editDisabled: boolean;
  goodDetails: DeclarationGoods;
}
export const ViewGoodLVDocuments: React.FC<ViewGoodLVDocumentsProps> = (props) => {
  const { declaration, goodDetails, editDisabled } = props;
  const { form, onSubmit, isSaving } = useDeclarationViewGoodLVForm({
    declaration,
    goodDetails,
    onHide: () => modals.closeAll(),
  });

  const handleDocuments = (doc: DocumentChangeProps) => {
    const refreshedDocuments = cloneDeep(form.values.documents);

    switch (doc.operation) {
      case MutateDeclarationDocumentOperation.CREATE: {
        refreshedDocuments[doc.type] = [...(refreshedDocuments[doc.type] || []), doc.data];
        break;
      }
      case MutateDeclarationDocumentOperation.UPDATE: {
        const documentToUpdate = getDeclarationDocumentById(doc.id, refreshedDocuments[doc.type]);
        const documentPos = refreshedDocuments[doc.type].findIndex((d) => d === documentToUpdate);
        refreshedDocuments[doc.type][documentPos] = doc.data;
        break;
      }
      case MutateDeclarationDocumentOperation.DELETE: {
        const index = getDeclarationDocumentPos(doc.data, doc.type, refreshedDocuments[doc.type]);

        if (index !== -1) {
          refreshedDocuments[doc.type].splice(index, 1);
        }
        break;
      }
      default:
        break;
    }

    form.setFieldValue('documents', refreshedDocuments);
  };

  return (
    <Stack>
      <DeclarationDocumentList
        documents={form.values.documents as Documents}
        editDisabled={editDisabled}
        includeDocumentTypes={[
          DeclarationDocumentsEnum.PREVIOUS_DOCUMENTS,
          DeclarationDocumentsEnum.SUPPORTING_DOCUMENTS,
          DeclarationDocumentsEnum.ADDITIONAL_REFERENCE,
          DeclarationDocumentsEnum.ADDITIONAL_INFORMATION,
          DeclarationDocumentsEnum.TRANSPORT_DOCUMENTS,
          DeclarationDocumentsEnum.ADDITIONAL_FISCAL_REFERENCE,
        ]}
        onDocumentChange={handleDocuments}
        defaultHeaderValue={false}
        headerDisabled={true}
        isHighValue={false}
        declaration={declaration}
        isGoodsItem={true}
      />
      <Group justify="center">
        <Button type="button" onClick={() => modals.closeAll()} disabled={isSaving} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="button" loading={isSaving} disabled={!form.isValid()} variant="filled" size="lg" onClick={() => onSubmit(form.values)}>
          Save documents
        </Button>
      </Group>
    </Stack>
  );
};
